import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NConfigProvider, GlobalThemeOverrides } from 'naive-ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeProvider',
  setup(__props) {

const themeOverrides: GlobalThemeOverrides = {
    common: {
        primaryColor: "#007277"
    },
    Menu : {
    itemIconColor: "gray",
    itemIconColorHover: "#007277",
    itemHeight: "40px",
    fontSize: "16px",
    itemIconColorCollapsed: "gray",
    itemIconColorActive: "#007277",
    itemIconColorActiveHover: "#007277",
    itemColorActive: "#e7e7e7",
    itemColorActiveHover: "#e7e7e7",
    itemTextColorHover: "#007277",
    itemTextColorActive: "#007277",
    itemTextColorActiveHover: "#007277",
    itemTextColor: "black",
  },
  Button : {
    heightMedium: '40px',
    textColor: 'white',
    color: '#007277',
    borderHover: '0px solid white',
    textColorHover: 'white',
    colorHover: 'rgba(0, 114, 119, .8)',
    borderRadiusSmall: '5px',
  },
  Message : {
    colorError: '#c93226',
    closeIconColorError: '#FFFFFF',
    iconColorError: '#FFFFFF',
    textColorError: '#FFFFFF',
  },
  Upload : {
    itemColorHover: '#ffb4b4',
    itemIconColor: '#000000',
    itemTextColorSuccess: '#007277',
  },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), { "theme-overrides": themeOverrides }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})